<template>
  <div class="grid-cell-tags">
    <span v-html="tags" />
  </div>
</template>

<script>
export default {
  computed: {
    tags () {
      return this.$helpers.showLongText(this.data.tags, 30)
    }
  }
}
</script>

<style lang="scss">
span.longTextNumber {
  color: $royalpurple-dark;
}
</style>
